import { render, staticRenderFns } from "./AllPosSettings.vue?vue&type=template&id=6f223b9b"
import script from "./AllPosSettings.vue?vue&type=script&lang=js"
export * from "./AllPosSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports